import Typography from '@mui/material/Typography';
import React from 'react';
import PageContainer from '../layout/PageContainer';
import BaseErrorBoundary from './Base';

class ErrorBoundary extends BaseErrorBoundary {
  render() {
    // Error path
    if (this.state.errorInfo) {
      return (
        <PageContainer>
          <Typography variant='h5'>
            An unexpected error has occurred. Please try again later.
          </Typography>

          <p>
            <Typography>
              Something didn't work out as well as we wanted it to and the page
              broke. We sent our team an automatic notification of this issue
              and we will be investigating it as soon as possible!
            </Typography>
          </p>

          <p>
            <Typography>
              In the meantime, feel free to{' '}
              <a href='' onClick={() => window.history.back()}>
                go back and try again
              </a>
              .
            </Typography>
          </p>

          <p>
            <Typography>
              If the issue persists, please contact Reliance Telephone.
            </Typography>
          </p>

          <details style={{ whiteSpace: 'pre-wrap' }}>
            <summary>Technical error details</summary>
            <div style={{ marginTop: 10 }}>
              <Typography>
                <strong style={{ marginTop: 10 }}>
                  {this.state.error && this.state.error.toString()}
                </strong>
              </Typography>
            </div>
            <pre>{'    ' + this.state.errorInfo.componentStack.trimLeft()}</pre>
          </details>
        </PageContainer>
      );
    }

    // Normally, just render children
    return this.props.children;
  }
}

export default ErrorBoundary;
